module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "v-table-views v-table-class",
    style: ({
      'width': _vm.internalWidth + 'px',
      'height': _vm.getTableHeight + 'px',
      'background-color': _vm.tableBgColor
    })
  }, [(_vm.frozenCols.length > 0) ? [_c('div', {
    staticClass: "v-table-leftview",
    style: ({
      'width': _vm.leftViewWidth + 'px'
    })
  }, [_c('div', {
    staticClass: "v-table-header v-table-title-class",
    style: ({
      'width': _vm.leftViewWidth + 'px',
      'background-color': _vm.titleBgColor
    })
  }, [_c('div', {
    staticClass: "v-table-header-inner",
    staticStyle: {
      "display": "block"
    }
  }, [_c('table', {
    staticClass: "v-table-htable",
    attrs: {
      "border": "0",
      "cellspacing": "0",
      "cellpadding": "0"
    }
  }, [_c('tbody', [(_vm.frozenTitleCols.length > 0) ? _vm._l((_vm.frozenTitleCols), function(row) {
    return _c('tr', _vm._l((row), function(col) {
      return _c('td', {
        class: [col.titleCellClassName],
        attrs: {
          "colspan": col.colspan,
          "rowspan": col.rowspan
        },
        on: {
          "mousemove": function($event) {
            $event.stopPropagation();
            _vm.handleTitleMouseMove($event, col.fields)
          },
          "mousedown": function($event) {
            $event.stopPropagation();
            _vm.handleTitleMouseDown($event)
          },
          "mouseout": function($event) {
            $event.stopPropagation();
            _vm.handleTitleMouseOut()
          },
          "click": function($event) {
            $event.stopPropagation();
            _vm.titleCellClick(col.fields, col.title);
          },
          "dblclick": function($event) {
            $event.stopPropagation();
            _vm.titleCellDblClick(col.fields, col.title)
          }
        }
      }, [_c('div', {
        class: ['v-table-title-cell', _vm.showVerticalBorder ? 'vertical-border' : '', _vm.showHorizontalBorder ? 'horizontal-border' : ''],
        style: ({
          'width': _vm.titleColumnWidth(col.fields) + 'px',
          'height': _vm.titleColumnHeight(col.rowspan) + 'px',
          'text-align': col.titleAlign
        })
      }, [_c('span', {
        staticClass: "table-title"
      }, [(_vm.isSelectionCol(col.fields)) ? _c('span', [_c('v-checkbox', {
        attrs: {
          "indeterminate": _vm.indeterminate,
          "show-slot": false,
          "label": "check-all"
        },
        on: {
          "change": _vm.handleCheckAll
        },
        model: {
          value: (_vm.isAllChecked),
          callback: function($$v) {
            _vm.isAllChecked = $$v
          },
          expression: "isAllChecked"
        }
      })], 1) : _c('span', {
        domProps: {
          "innerHTML": _vm._s(col.title)
        }
      }), _vm._v(" "), (_vm.enableSort(col.orderBy)) ? _c('span', {
        staticClass: "v-table-sort-icon",
        on: {
          "click": function($event) {
            $event.stopPropagation();
            _vm.sortControl(col.fields[0])
          }
        }
      }, [_c('i', {
        class: ["v-icon-up-dir", _vm.getCurrentSort(col.fields[0]) === "asc" ? "checked" : ""]
      }), _vm._v(" "), _c('i', {
        class: ["v-icon-down-dir", _vm.getCurrentSort(col.fields[0]) === "desc" ? "checked" : ""]
      })]) : _vm._e()]), _vm._v(" "), (_vm.enableFilters(col.filters, col.fields)) ? _c('v-dropdown', {
        staticClass: "v-table-dropdown",
        attrs: {
          "show-operation": col.filterMultiple,
          "is-multiple": col.filterMultiple
        },
        on: {
          "on-filter-method": _vm.filterEvent,
          "change": function($event) {
            _vm.filterConditionChange(col.filterMultiple)
          }
        },
        model: {
          value: (col.filters),
          callback: function($$v) {
            _vm.$set(col, "filters", $$v)
          },
          expression: "col.filters"
        }
      }, [_c('i', {
        class: ['v-table-filter-icon', _vm.vTableFiltersIcon(col.filters)]
      })]) : _vm._e()], 1)])
    }))
  }) : [_c('tr', {
    staticClass: "v-table-header-row"
  }, _vm._l((_vm.frozenCols), function(col) {
    return _c('td', {
      class: [col.titleCellClassName],
      on: {
        "mousemove": function($event) {
          $event.stopPropagation();
          _vm.handleTitleMouseMove($event, col.field)
        },
        "mousedown": function($event) {
          $event.stopPropagation();
          _vm.handleTitleMouseDown($event)
        },
        "mouseout": function($event) {
          $event.stopPropagation();
          _vm.handleTitleMouseOut()
        },
        "click": function($event) {
          $event.stopPropagation();
          _vm.titleCellClick(col.field, col.title);
        },
        "dblclick": function($event) {
          $event.stopPropagation();
          _vm.titleCellDblClick(col.field, col.title)
        }
      }
    }, [_c('div', {
      class: ['v-table-title-cell', _vm.showVerticalBorder ? 'vertical-border' : '', _vm.showHorizontalBorder ? 'horizontal-border' : ''],
      style: ({
        'width': col.width + 'px',
        'height': _vm.titleRowHeight + 'px',
        'text-align': col.titleAlign
      })
    }, [_c('span', {
      staticClass: "table-title"
    }, [(col.type === 'selection') ? _c('span', [_c('v-checkbox', {
      attrs: {
        "indeterminate": _vm.indeterminate,
        "show-slot": false,
        "label": "check-all"
      },
      on: {
        "change": _vm.handleCheckAll
      },
      model: {
        value: (_vm.isAllChecked),
        callback: function($$v) {
          _vm.isAllChecked = $$v
        },
        expression: "isAllChecked"
      }
    })], 1) : _c('span', {
      domProps: {
        "innerHTML": _vm._s(col.title)
      }
    }), _vm._v(" "), (_vm.enableSort(col.orderBy)) ? _c('span', {
      staticClass: "v-table-sort-icon",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.sortControl(col.field)
        }
      }
    }, [_c('i', {
      class: ["v-icon-up-dir", _vm.getCurrentSort(col.field) === "asc" ? "checked" : ""]
    }), _vm._v(" "), _c('i', {
      class: ["v-icon-down-dir", _vm.getCurrentSort(col.field) === "desc" ? "checked" : ""]
    })]) : _vm._e()]), _vm._v(" "), (_vm.enableFilters(col.filters)) ? _c('v-dropdown', {
      staticClass: "v-table-dropdown",
      attrs: {
        "show-operation": col.filterMultiple,
        "is-multiple": col.filterMultiple
      },
      on: {
        "on-filter-method": _vm.filterEvent,
        "change": function($event) {
          _vm.filterConditionChange(col.filterMultiple)
        }
      },
      model: {
        value: (col.filters),
        callback: function($$v) {
          _vm.$set(col, "filters", $$v)
        },
        expression: "col.filters"
      }
    }, [_c('i', {
      class: ['v-table-filter-icon', _vm.vTableFiltersIcon(col.filters)]
    })]) : _vm._e()], 1)])
  }))]], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "v-table-body v-table-body-class",
    style: ({
      'width': _vm.leftViewWidth + 'px',
      'height': _vm.bodyViewHeight + 'px'
    })
  }, [_c('div', {
    class: ['v-table-body-inner', _vm.vTableBodyInner]
  }, [_c('v-checkbox-group', {
    on: {
      "change": _vm.handleCheckGroupChange
    },
    model: {
      value: (_vm.checkboxGroupModel),
      callback: function($$v) {
        _vm.checkboxGroupModel = $$v
      },
      expression: "checkboxGroupModel"
    }
  }, [_c('table', {
    staticClass: "v-table-btable",
    attrs: {
      "cellspacing": "0",
      "cellpadding": "0",
      "border": "0"
    }
  }, [_c('tbody', _vm._l((_vm.internalTableData), function(item, rowIndex) {
    return _c('tr', {
      staticClass: "v-table-row",
      style: ([_vm.trBgColor(rowIndex + 1)]),
      on: {
        "mouseenter": function($event) {
          $event.stopPropagation();
          _vm.handleMouseEnter(rowIndex)
        },
        "mouseleave": function($event) {
          $event.stopPropagation();
          _vm.handleMouseOut(rowIndex)
        }
      }
    }, _vm._l((_vm.frozenCols), function(col, colIndex) {
      return (_vm.cellMergeInit(rowIndex, col.field, item, true)) ? _c('td', {
        key: colIndex,
        class: [_vm.setColumnCellClassName(rowIndex, col.field, item)],
        attrs: {
          "colSpan": _vm.setColRowSpan(rowIndex, col.field, item).colSpan,
          "rowSpan": _vm.setColRowSpan(rowIndex, col.field, item).rowSpan
        }
      }, [(_vm.isCellMergeRender(rowIndex, col.field, item)) ? _c('div', {
        class: ['v-table-body-cell', _vm.showVerticalBorder ? 'vertical-border' : '', _vm.showHorizontalBorder ? 'horizontal-border' : ''],
        style: ({
          'width': _vm.getRowWidthByColSpan(rowIndex, col.field, item) + 'px',
          'height': _vm.getRowHeightByRowSpan(rowIndex, col.field, item) + 'px',
          'line-height': _vm.getRowHeightByRowSpan(rowIndex, col.field, item) + 'px',
          'text-align': col.columnAlign
        }),
        attrs: {
          "title": col.overflowTitle ? _vm.overflowTitle(item, rowIndex, col) : ''
        },
        on: {
          "click": function($event) {
            $event.stopPropagation();
            _vm.rowCellClick(rowIndex, item, col);
            _vm.cellEditClick($event, col.isEdit, item, col.field, rowIndex)
          },
          "dblclick": function($event) {
            $event.stopPropagation();
            _vm.rowCellDbClick(rowIndex, item, col)
          }
        }
      }, [(_vm.cellMergeContentType(rowIndex, col.field, item).isComponent) ? _c('span', [_c(_vm.cellMerge(rowIndex, item, col.field).componentName, {
        tag: "component",
        attrs: {
          "rowData": item,
          "field": col.field ? col.field : '',
          "index": rowIndex
        },
        on: {
          "on-custom-comp": _vm.customCompFunc
        }
      })], 1) : _c('span', {
        domProps: {
          "innerHTML": _vm._s(_vm.cellMerge(rowIndex, item, col.field).content)
        }
      })]) : _c('div', {
        class: ['v-table-body-cell', _vm.showVerticalBorder ? 'vertical-border' : '', _vm.showHorizontalBorder ? 'horizontal-border' : ''],
        style: ({
          'width': col.width + 'px',
          'height': _vm.rowHeight + 'px',
          'line-height': _vm.rowHeight + 'px',
          'text-align': col.columnAlign
        }),
        attrs: {
          "title": col.overflowTitle ? _vm.overflowTitle(item, rowIndex, col) : ''
        },
        on: {
          "click": function($event) {
            $event.stopPropagation();
            _vm.rowCellClick(rowIndex, item, col);
            _vm.cellEditClick($event, col.isEdit, item, col.field, rowIndex)
          },
          "dblclick": function($event) {
            $event.stopPropagation();
            _vm.rowCellDbClick(rowIndex, item, col)
          }
        }
      }, [(typeof col.componentName === 'string' && col.componentName.length > 0) ? _c('span', [_c(col.componentName, {
        tag: "component",
        attrs: {
          "rowData": item,
          "field": col.field ? col.field : '',
          "index": rowIndex
        },
        on: {
          "on-custom-comp": _vm.customCompFunc
        }
      })], 1) : (typeof col.formatter === 'function') ? _c('span', {
        domProps: {
          "innerHTML": _vm._s(col.formatter(item, rowIndex, _vm.pagingIndex, col.field))
        }
      }) : (col.type === 'selection') ? _c('span', [_c('v-checkbox', {
        attrs: {
          "show-slot": false,
          "disabled": item._disabled,
          "label": rowIndex
        },
        on: {
          "change": function($event) {
            _vm.handleCheckChange(item)
          }
        }
      })], 1) : _c('span', [_vm._v("\n                                            " + _vm._s(item[col.field]) + "\n                                    ")])])]) : _vm._e()
    }))
  }))])])], 1)]), _vm._v(" "), (_vm.frozenFooterCols.length > 0) ? _c('div', {
    class: ['v-table-footer', 'v-table-footer-class'],
    style: ({
      'width': _vm.leftViewWidth + 'px',
      'height': _vm.footerTotalHeight
    })
  }, [_c('table', {
    staticClass: "v-table-ftable",
    attrs: {
      "cellspacing": "0",
      "cellpadding": "0",
      "border": "0"
    }
  }, _vm._l((_vm.frozenFooterCols), function(item, rowIndex) {
    return _c('tr', {
      staticClass: "v-table-row"
    }, _vm._l((item), function(col, colIndex) {
      return _c('td', {
        class: _vm.setFooterCellClassName(true, rowIndex, colIndex, col.content)
      }, [_c('div', {
        class: ['v-table-body-cell', _vm.vTableBodyCell],
        style: ({
          'height': _vm.footerRowHeight + 'px',
          'line-height': _vm.footerRowHeight + 'px',
          'width': col.width + 'px',
          'text-align': col.align
        }),
        domProps: {
          "innerHTML": _vm._s(col.content)
        }
      })])
    }))
  }))]) : _vm._e()])] : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "v-table-rightview",
    style: ({
      'width': _vm.rightViewWidth + 'px'
    })
  }, [_c('div', {
    staticClass: "v-table-header v-table-title-class",
    style: ({
      'width': (_vm.rightViewWidth - 1) + 'px',
      'background-color': _vm.titleBgColor
    })
  }, [_c('div', {
    staticClass: "v-table-header-inner",
    staticStyle: {
      "display": "block"
    }
  }, [_c('table', {
    staticClass: "v-table-htable",
    attrs: {
      "border": "0",
      "cellspacing": "0",
      "cellpadding": "0"
    }
  }, [_c('tbody', [(_vm.noFrozenTitleCols.length > 0) ? _vm._l((_vm.noFrozenTitleCols), function(row) {
    return _c('tr', _vm._l((row), function(col) {
      return _c('td', {
        class: [col.titleCellClassName],
        attrs: {
          "colspan": col.colspan,
          "rowspan": col.rowspan
        },
        on: {
          "mousemove": function($event) {
            $event.stopPropagation();
            _vm.handleTitleMouseMove($event, col.fields)
          },
          "mousedown": function($event) {
            $event.stopPropagation();
            _vm.handleTitleMouseDown($event)
          },
          "mouseout": function($event) {
            $event.stopPropagation();
            _vm.handleTitleMouseOut()
          },
          "click": function($event) {
            $event.stopPropagation();
            _vm.titleCellClick(col.fields, col.title);
          },
          "dblclick": function($event) {
            $event.stopPropagation();
            _vm.titleCellDblClick(col.fields, col.title)
          }
        }
      }, [_c('div', {
        class: ['v-table-title-cell', _vm.showVerticalBorder ? 'vertical-border' : '', _vm.showHorizontalBorder ? 'horizontal-border' : ''],
        style: ({
          'width': _vm.titleColumnWidth(col.fields) + 'px',
          'height': _vm.titleColumnHeight(col.rowspan) + 'px',
          'text-align': col.titleAlign
        })
      }, [_c('span', {
        staticClass: "table-title"
      }, [(_vm.isSelectionCol(col.fields)) ? _c('span', [_c('v-checkbox', {
        attrs: {
          "indeterminate": _vm.indeterminate,
          "show-slot": false,
          "label": "check-all"
        },
        on: {
          "change": _vm.handleCheckAll
        },
        model: {
          value: (_vm.isAllChecked),
          callback: function($$v) {
            _vm.isAllChecked = $$v
          },
          expression: "isAllChecked"
        }
      })], 1) : _c('span', {
        domProps: {
          "innerHTML": _vm._s(col.title)
        }
      }), _vm._v(" "), (_vm.enableSort(col.orderBy)) ? _c('span', {
        staticClass: "v-table-sort-icon",
        on: {
          "click": function($event) {
            $event.stopPropagation();
            _vm.sortControl(col.fields[0])
          }
        }
      }, [_c('i', {
        class: ["v-icon-up-dir", _vm.getCurrentSort(col.fields[0]) === "asc" ? "checked" : ""]
      }), _vm._v(" "), _c('i', {
        class: ["v-icon-down-dir", _vm.getCurrentSort(col.fields[0]) === "desc" ? "checked" : ""]
      })]) : _vm._e()]), _vm._v(" "), (_vm.enableFilters(col.filters, col.fields)) ? _c('v-dropdown', {
        staticClass: "v-table-dropdown",
        attrs: {
          "show-operation": col.filterMultiple,
          "is-multiple": col.filterMultiple
        },
        on: {
          "on-filter-method": _vm.filterEvent,
          "change": function($event) {
            _vm.filterConditionChange(col.filterMultiple)
          }
        },
        model: {
          value: (col.filters),
          callback: function($$v) {
            _vm.$set(col, "filters", $$v)
          },
          expression: "col.filters"
        }
      }, [_c('i', {
        class: ['v-table-filter-icon', _vm.vTableFiltersIcon(col.filters)]
      })]) : _vm._e()], 1)])
    }))
  }) : [_c('tr', {
    staticClass: "v-table-header-row"
  }, _vm._l((_vm.noFrozenCols), function(col, colIndex) {
    return _c('td', {
      class: [col.titleCellClassName],
      on: {
        "mousemove": function($event) {
          $event.stopPropagation();
          _vm.handleTitleMouseMove($event, col.field)
        },
        "mousedown": function($event) {
          $event.stopPropagation();
          _vm.handleTitleMouseDown($event)
        },
        "mouseout": function($event) {
          $event.stopPropagation();
          _vm.handleTitleMouseOut()
        },
        "click": function($event) {
          $event.stopPropagation();
          _vm.titleCellClick(col.field, col.title);
        },
        "dblclick": function($event) {
          $event.stopPropagation();
          _vm.titleCellDblClick(col.field, col.title)
        }
      }
    }, [_c('div', {
      class: ['v-table-title-cell', _vm.showVerticalBorder ? 'vertical-border' : '', _vm.showHorizontalBorder ? 'horizontal-border' : ''],
      style: ({
        'width': col.width + 'px',
        'height': _vm.titleRowHeight + 'px',
        'text-align': col.titleAlign
      })
    }, [_c('span', {
      staticClass: "table-title"
    }, [(col.type === 'selection') ? _c('span', [_c('v-checkbox', {
      attrs: {
        "indeterminate": _vm.indeterminate,
        "show-slot": false,
        "label": "check-all"
      },
      on: {
        "change": _vm.handleCheckAll
      },
      model: {
        value: (_vm.isAllChecked),
        callback: function($$v) {
          _vm.isAllChecked = $$v
        },
        expression: "isAllChecked"
      }
    })], 1) : _c('span', {
      domProps: {
        "innerHTML": _vm._s(col.title)
      }
    }), _vm._v(" "), (_vm.enableSort(col.orderBy)) ? _c('span', {
      staticClass: "v-table-sort-icon",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.sortControl(col.field)
        }
      }
    }, [_c('i', {
      class: ["v-icon-up-dir", _vm.getCurrentSort(col.field) === "asc" ? "checked" : ""]
    }), _vm._v(" "), _c('i', {
      class: ["v-icon-down-dir", _vm.getCurrentSort(col.field) === "desc" ? "checked" : ""]
    })]) : _vm._e(), _vm._v(" "), (_vm.enableFilters(col.filters)) ? _c('v-dropdown', {
      staticClass: "v-table-dropdown",
      attrs: {
        "show-operation": col.filterMultiple,
        "is-multiple": col.filterMultiple
      },
      on: {
        "on-filter-method": _vm.filterEvent,
        "change": function($event) {
          _vm.filterConditionChange(col.filterMultiple)
        }
      },
      model: {
        value: (col.filters),
        callback: function($$v) {
          _vm.$set(col, "filters", $$v)
        },
        expression: "col.filters"
      }
    }, [_c('i', {
      class: ['v-table-filter-icon', _vm.vTableFiltersIcon(col.filters)]
    })]) : _vm._e()], 1)])])
  }))]], 2)])])]), _vm._v(" "), _c('div', {
    class: ['v-table-body v-table-body-class', _vm.vTableRightBody],
    style: ({
      'width': _vm.rightViewWidth + 'px',
      'height': _vm.bodyViewHeight + 'px'
    })
  }, [_c('v-checkbox-group', {
    on: {
      "change": _vm.handleCheckGroupChange
    },
    model: {
      value: (_vm.checkboxGroupModel),
      callback: function($$v) {
        _vm.checkboxGroupModel = $$v
      },
      expression: "checkboxGroupModel"
    }
  }, [_c('table', {
    staticClass: "v-table-btable",
    attrs: {
      "cellspacing": "0",
      "cellpadding": "0",
      "border": "0"
    }
  }, [_c('tbody', _vm._l((_vm.internalTableData), function(item, rowIndex) {
    return _c('tr', {
      key: rowIndex,
      staticClass: "v-table-row",
      style: ([_vm.trBgColor(rowIndex + 1)]),
      on: {
        "mouseenter": function($event) {
          $event.stopPropagation();
          _vm.handleMouseEnter(rowIndex)
        },
        "mouseleave": function($event) {
          $event.stopPropagation();
          _vm.handleMouseOut(rowIndex)
        }
      }
    }, _vm._l((_vm.noFrozenCols), function(col, colIndex) {
      return (_vm.cellMergeInit(rowIndex, col.field, item, false)) ? _c('td', {
        key: colIndex,
        class: [_vm.setColumnCellClassName(rowIndex, col.field, item)],
        attrs: {
          "colSpan": _vm.setColRowSpan(rowIndex, col.field, item).colSpan,
          "rowSpan": _vm.setColRowSpan(rowIndex, col.field, item).rowSpan
        }
      }, [(_vm.isCellMergeRender(rowIndex, col.field, item)) ? _c('div', {
        class: ['v-table-body-cell', _vm.showVerticalBorder ? 'vertical-border' : '', _vm.showHorizontalBorder ? 'horizontal-border' : ''],
        style: ({
          'width': _vm.getRowWidthByColSpan(rowIndex, col.field, item) + 'px',
          'height': _vm.getRowHeightByRowSpan(rowIndex, col.field, item) + 'px',
          'line-height': _vm.getRowHeightByRowSpan(rowIndex, col.field, item) + 'px',
          'text-align': col.columnAlign
        }),
        attrs: {
          "title": col.overflowTitle ? _vm.overflowTitle(item, rowIndex, col) : ''
        },
        on: {
          "click": function($event) {
            $event.stopPropagation();
            _vm.rowCellClick(rowIndex, item, col);
            _vm.cellEditClick($event, col.isEdit, item, col.field, rowIndex)
          },
          "dblclick": function($event) {
            $event.stopPropagation();
            _vm.rowCellDbClick(rowIndex, item, col)
          }
        }
      }, [(_vm.cellMergeContentType(rowIndex, col.field, item).isComponent) ? _c('span', [_c(_vm.cellMerge(rowIndex, item, col.field).componentName, {
        tag: "component",
        attrs: {
          "rowData": item,
          "field": col.field ? col.field : '',
          "index": rowIndex
        },
        on: {
          "on-custom-comp": _vm.customCompFunc
        }
      })], 1) : _c('span', {
        domProps: {
          "innerHTML": _vm._s(_vm.cellMerge(rowIndex, item, col.field).content)
        }
      })]) : _c('div', {
        class: ['v-table-body-cell', _vm.showVerticalBorder ? 'vertical-border' : '', _vm.showHorizontalBorder ? 'horizontal-border' : ''],
        style: ({
          'width': col.width + 'px',
          'height': _vm.rowHeight + 'px',
          'line-height': _vm.rowHeight + 'px',
          'text-align': col.columnAlign
        }),
        attrs: {
          "title": col.overflowTitle ? _vm.overflowTitle(item, rowIndex, col) : ''
        },
        on: {
          "click": function($event) {
            $event.stopPropagation();
            _vm.rowCellClick(rowIndex, item, col);
            _vm.cellEditClick($event, col.isEdit, item, col.field, rowIndex)
          },
          "dblclick": function($event) {
            $event.stopPropagation();
            _vm.rowCellDbClick(rowIndex, item, col)
          }
        }
      }, [(typeof col.componentName === 'string' && col.componentName.length > 0) ? _c('span', [_c(col.componentName, {
        tag: "component",
        attrs: {
          "rowData": item,
          "field": col.field ? col.field : '',
          "index": rowIndex
        },
        on: {
          "on-custom-comp": _vm.customCompFunc
        }
      })], 1) : (typeof col.formatter === 'function') ? _c('span', {
        domProps: {
          "innerHTML": _vm._s(col.formatter(item, rowIndex, _vm.pagingIndex, col.field))
        }
      }) : (col.type === 'selection') ? _c('span', [_c('v-checkbox', {
        attrs: {
          "show-slot": false,
          "disabled": item._disabled,
          "label": rowIndex
        },
        on: {
          "change": function($event) {
            _vm.handleCheckChange(item)
          }
        }
      })], 1) : _c('span', [_vm._v("\n                                 " + _vm._s(item[col.field]) + "\n                            ")])])]) : _vm._e()
    }))
  }))])])], 1), _vm._v(" "), (_vm.noFrozenFooterCols.length > 0) ? _c('div', {
    class: ['v-table-footer', 'v-table-footer-class', _vm.vTableFooter],
    style: ({
      'width': _vm.rightViewWidth + 'px',
      'height': _vm.footerTotalHeight
    })
  }, [_c('table', {
    staticClass: "v-table-ftable",
    attrs: {
      "cellspacing": "0",
      "cellpadding": "0",
      "border": "0"
    }
  }, _vm._l((_vm.noFrozenFooterCols), function(item, rowIndex) {
    return _c('tr', {
      staticClass: "v-table-row"
    }, _vm._l((item), function(col, colIndex) {
      return _c('td', {
        class: _vm.setFooterCellClassName(false, rowIndex, colIndex, col.content)
      }, [_c('div', {
        class: ['v-table-body-cell', _vm.vTableBodyCell],
        style: ({
          'height': _vm.footerRowHeight + 'px',
          'line-height': _vm.footerRowHeight + 'px',
          'width': col.width + 'px',
          'text-align': col.align
        }),
        domProps: {
          "innerHTML": _vm._s(col.content)
        }
      })])
    }))
  }))]) : _vm._e()]), _vm._v(" "), (_vm.isTableEmpty) ? _c('table-empty', {
    attrs: {
      "width": _vm.internalWidth,
      "total-columns-width": _vm.totalColumnsWidth,
      "content-height": _vm.errorContentHeight,
      "title-height": _vm.getTotalColumnsHeight(),
      "error-content": _vm.errorContent,
      "is-loading": _vm.isLoading
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isLoading) ? _c('loading', {
    attrs: {
      "loading-content": _vm.loadingContent,
      "title-rows": _vm.internalTitleRows,
      "title-row-height": _vm.titleRowHeight,
      "columns": _vm.internalColumns,
      "loading-opacity": _vm.loadingOpacity
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isDragging),
      expression: "isDragging"
    }],
    staticClass: "v-table-drag-line"
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2684fe96"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-easytable/libs/v-table/src/table.vue
// module id = 1648
// module chunks = 1